import { ArrowLeft } from 'lucide-react'

import { Page } from '../../../../../components/layouts/page'
import { Header } from '../../../_components/Header'
import { Column } from '../../../../../components/layouts/columns'
import { Button } from '../../../../../components/ui/button'
import cardImg from '../../../../../assets/cartao_credito_keap_staff_1.png'
import { Input } from '../../../../../components/ui/input'
import { Form } from '../../../../../components/ui/form'
import useCollaboratorRegisterPayment from '../../../_hooks/useCollaboratorSignPlanRecurrence'
import { AlertFunctional } from '../../../../../components/ui/alert/AlertFunctional'
import { Path } from '../../../../../router/paths'

export const CollaboratorRegisterPayment = () => {
  const {
    token,
    loading,
    bandeiras,
    alerts,
    setAlerts,
    formContext,
    setFormContext,
    HandleCreateNewAssinantePagBank,
    formatCardNumber,
    formatExpiryDate,
    getCardBrand,
  } = useCollaboratorRegisterPayment()

  return (
    <Page.Root className="pb-6">
      <Page.Content
        style={{
          maxWidth: '400px', // Largura máxima para telas menores
          width: '100%', // Garante que se adapte bem a telas menores
          margin: '0 auto', // Centraliza o conteúdo
        }}
      >
        <Header>
          <a href={Path.CollabSignPlan(token)}>
            <ArrowLeft className="has-text-link" size={30} />
          </a>
        </Header>

        <p className="mt-6 subtitle has-text-centered">Contratação {formContext.name}</p>

        <Column.Root
          className="mt-6"
          style={{
            color: 'rgb(151, 151, 151)',
          }}
        >
          {/* Card */}
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <img style={{ width: '100%' }} src={cardImg} alt="" />
            <div>
              {/* FLAG */}

              <div
                style={{
                  position: 'absolute',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  top: '2rem',
                  left: '17rem',
                  color: '#fff',
                  fontSize: '18px',
                  letterSpacing: '0.5rem',
                  width: '4rem',
                  height: '3rem',
                }}
              >
                <img
                  src={bandeiras[getCardBrand(formContext?.numero_cartao || '0')].path}
                  alt={`${bandeiras[getCardBrand(formContext?.numero_cartao || '0')].banco}`}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                  }}
                />
              </div>

              {/* NUMBER CARD */}
              <div
                style={{
                  position: 'absolute',
                  top: '5.5rem',
                  left: '3rem',
                  color: '#fff',
                  fontSize: '18px',
                  letterSpacing: '0.5rem',
                }}
              >
                {formatCardNumber(formContext.numero_cartao)}
              </div>

              {/* CVC */}
              <div
                style={{
                  position: 'absolute',
                  top: '7.8rem',
                  left: '3rem',
                }}
              >
                <p style={{ margin: 0, fontSize: '0.75rem' }}>CVC</p>
                <p style={{ fontSize: '1rem', color: '#fff' }}>{formContext?.cvc || '***'}</p>
              </div>

              {/* DATE */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'end',
                  position: 'absolute',
                  top: '7.8rem',
                  left: '19rem',
                }}
              >
                <p style={{ margin: 0, fontSize: '0.75rem' }}>Validade</p>
                <p style={{ fontSize: '1rem', color: '#fff' }}>
                  {formatExpiryDate(formContext?.validade_cartao || 'MM/AA')}
                </p>
              </div>

              {/* NAME CARD */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'absolute',
                  top: '11rem',
                  left: '3rem',
                }}
              >
                <p style={{ fontSize: '1rem', color: '#fff', letterSpacing: '0.2rem', textTransform: 'uppercase' }}>
                  {formContext?.nome_cartao || 'nome no cartão'}
                </p>
              </div>
            </div>
          </div>
        </Column.Root>

        <Form.Root action={() => HandleCreateNewAssinantePagBank()}>
          {/* CARD DATA */}
          <Column.Root className="box mb-6">
            <Column.Content>
              <Column.Root>
                <Column.Content>
                  <p className="subtitle is-size-5">Dados do Cartão</p>
                </Column.Content>
              </Column.Root>
              <Column.Root>
                <Column.Content>
                  <Input.Root>
                    <Input.Label required className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                      Número do Cartão
                    </Input.Label>
                    <Input.Contents>
                      <Input.Prompt
                        className="is-rounded"
                        placeholder="9999 9999 9999 9999"
                        color="is-grey"
                        field={'numero_cartao'}
                        required={true}
                        maxLength={16}
                        value={formContext}
                        setValue={setFormContext}
                      ></Input.Prompt>
                    </Input.Contents>
                  </Input.Root>
                </Column.Content>
              </Column.Root>
              <Column.Root>
                <Column.Content>
                  <Input.Root>
                    <Input.Label required className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                      Validade do Cartão
                    </Input.Label>
                    <Input.Contents>
                      <Input.Prompt
                        className="is-rounded"
                        color="is-grey"
                        type="text"
                        field={'validade_cartao'}
                        placeholder="02/2035"
                        maskValue="date"
                        maskSetValue="date"
                        maxLength={7}
                        required={true}
                        value={formContext}
                        setValue={setFormContext}
                      ></Input.Prompt>
                    </Input.Contents>
                  </Input.Root>
                </Column.Content>
                <Column.Content>
                  <Input.Root>
                    <Input.Label required className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                      CVC
                    </Input.Label>
                    <Input.Contents>
                      <Input.Prompt
                        className="is-rounded"
                        color="is-grey"
                        required={true}
                        field={'cvc'}
                        placeholder="***"
                        value={formContext}
                        setValue={setFormContext}
                      ></Input.Prompt>
                    </Input.Contents>
                  </Input.Root>
                </Column.Content>
              </Column.Root>
              <Column.Root>
                <Column.Content>
                  <Input.Root>
                    <Input.Label required className="ml-3 has-text-grey" style={{ margin: 0 }}>
                      Nome Impresso no Cartão
                    </Input.Label>
                    <Input.Contents>
                      <Input.Prompt
                        className="is-rounded"
                        color="is-grey"
                        type="text"
                        field={'nome_cartao'}
                        placeholder="Jhon Doe"
                        value={formContext}
                        style={{ textTransform: 'uppercase' }}
                        setValue={setFormContext}
                        required={true}
                      ></Input.Prompt>
                    </Input.Contents>
                  </Input.Root>
                </Column.Content>
              </Column.Root>
            </Column.Content>
          </Column.Root>
          {/* BILLING ADDRESS */}
          <Column.Root className="box mb-6">
            <Column.Content>
              <Column.Root>
                <Column.Content>
                  <p className="subtitle is-size-5">Contato</p>
                </Column.Content>
              </Column.Root>
              <Column.Root>
                <Column.Content>
                  <Input.Root className="">
                    <Input.Label required className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                      Telefone de Contato
                    </Input.Label>
                    <Input.Contents>
                      <Input.Prompt
                        maskSetValue="tel"
                        maskValue="tel"
                        className="is-rounded"
                        color="is-grey"
                        field={'phones'}
                        value={formContext}
                        setValue={setFormContext}
                        required={true}
                      ></Input.Prompt>
                    </Input.Contents>
                  </Input.Root>
                </Column.Content>
              </Column.Root>
            </Column.Content>
          </Column.Root>

          <Column.Root className="box">
            <Column.Content>
              <Column.Root>
                <Column.Content>
                  <p className="subtitle is-size-5">Endereço de Cobrança</p>
                </Column.Content>
              </Column.Root>
              <Column.Root>
                <Column.Content>
                  <Column.Root>
                    <Column.Content>
                      <Input.Root className="">
                        <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                          CEP
                        </Input.Label>
                        <Input.Contents>
                          <Input.Prompt
                            className="is-rounded"
                            color="is-grey"
                            value={formContext}
                            setValue={setFormContext}
                            field={'zipcode'}
                            required={true}
                            maskValue={'cep'}
                            maskSetValue={'lower'}
                            type="text"
                          ></Input.Prompt>
                        </Input.Contents>
                      </Input.Root>
                      <Input.Error>
                        {!formContext?.zipcode
                          ? 'Digite o cep para preencher automaticamente as informações de endereço'
                          : ''}
                      </Input.Error>
                    </Column.Content>
                  </Column.Root>

                  <Column.Root>
                    <Column.Content>
                      <Input.Root className="">
                        <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                          Endereço
                        </Input.Label>
                        <Input.Contents>
                          <Input.Prompt
                            className="is-rounded"
                            color="is-grey"
                            field={'street'}
                            required={true}
                            value={formContext}
                            setValue={setFormContext}
                            maskValue={'title'}
                            type="text"
                            maskSetValue={'lower'}
                          ></Input.Prompt>
                        </Input.Contents>
                      </Input.Root>
                    </Column.Content>
                  </Column.Root>

                  <Column.Root>
                    <Column.Content>
                      <Input.Root className="">
                        <Input.Label required className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                          Bairro
                        </Input.Label>
                        <Input.Contents>
                          <Input.Prompt
                            className="is-rounded"
                            color="is-grey"
                            field={'district'}
                            type="text"
                            required={true}
                            value={formContext}
                            setValue={setFormContext}
                          ></Input.Prompt>
                        </Input.Contents>
                      </Input.Root>
                    </Column.Content>
                  </Column.Root>

                  <Column.Root>
                    <Column.Content>
                      <Input.Root className="">
                        <Input.Label required className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                          Cidade
                        </Input.Label>
                        <Input.Contents>
                          <Input.Prompt
                            className="is-rounded"
                            color="is-grey"
                            field={'city'}
                            required={true}
                            value={formContext}
                            setValue={setFormContext}
                          ></Input.Prompt>
                        </Input.Contents>
                      </Input.Root>
                    </Column.Content>
                  </Column.Root>

                  <Column.Root>
                    <Column.Content>
                      <Input.Root className="">
                        <Input.Label required className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                          Estado
                        </Input.Label>
                        <Input.Contents>
                          <Input.Prompt
                            className="is-rounded"
                            color="is-grey"
                            field={'state'}
                            type="text"
                            value={formContext}
                            required={true}
                            setValue={setFormContext}
                          ></Input.Prompt>
                        </Input.Contents>
                      </Input.Root>
                    </Column.Content>
                  </Column.Root>

                  <Column.Root>
                    <Column.Content>
                      <Input.Root className="">
                        <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                          Número Residencial
                        </Input.Label>
                        <Input.Contents>
                          <Input.Prompt
                            className="is-rounded"
                            color="is-grey"
                            field={'number'}
                            value={formContext}
                            setValue={setFormContext}
                            required={true}
                          ></Input.Prompt>
                        </Input.Contents>
                      </Input.Root>
                    </Column.Content>
                  </Column.Root>

                  <Column.Root>
                    <Column.Content>
                      <Input.Root className="">
                        <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                          Complemento
                        </Input.Label>
                        <Input.Contents>
                          <Input.Prompt
                            className="is-rounded"
                            color="is-grey"
                            field={'complement'}
                            type="text"
                            value={formContext}
                            setValue={setFormContext}
                          ></Input.Prompt>
                        </Input.Contents>
                      </Input.Root>
                    </Column.Content>
                  </Column.Root>
                </Column.Content>
              </Column.Root>
            </Column.Content>
          </Column.Root>

          <Column.Root>
            <Column.Content>
              <Button.Bt
                className="mt-6 is-fullwidth"
                color="is-primary"
                colorText={'has-text-link'}
                loading={loading}
                type="submit"
              >
                Continuar
              </Button.Bt>
            </Column.Content>
          </Column.Root>
        </Form.Root>
      </Page.Content>
      <AlertFunctional values={alerts} setValues={setAlerts} />
    </Page.Root>
  )
}
